import ShiftDto from "@/models/Shifts/ShiftDto";

export default class DateTimeUtils {

    static calculateShiftLength(startAtTime: string, endAtTime: string) {
        
        //create date format          
        const timeStart = new Date("01/01/2000 " + startAtTime).getHours();
        const timeEnd = new Date("01/01/2000 " + endAtTime).getHours();

        let totalHours = timeEnd - timeStart;

        //Handle next day
        if (totalHours < 0) {
        totalHours = 24 + totalHours;
        }
        return totalHours
    }

    static datesAreOnSameDay(first: Date, second: Date) {
        return (first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate());
    }

    static toShortDate(date: Date) {
        const months = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ]
        return `${date.getDate()} ${months[date.getMonth()]}`;
    }

    static getThisMondayAsIso() { 
        const today = new Date();
        const day = today.getDay(),
        diff = today.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
        return new Date(today.setDate(diff)).toISOString().substr(0, 10)
    }

    static getTodayAsIso() { 
        return new Date().toISOString().substring(0, 10)
    }

    static toDDMMYY(value: Date) {
        const date = new Date(value)  
        const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
        const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
        const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
        return `${da}/${mo}/${ye}`;
    }

    static toYYMMDD(value: Date) {
        const date = new Date(value)  
        const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
        const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
        const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
        return `${ye}-${mo}-${da}`;
    }

    static toHHMM(value: Date) {
        let datetext = value.toTimeString();
        // datestring is "20:32:01 GMT+0530 (India Standard Time)"
        // Split with ' ' and we get: ["20:32:01", "GMT+0530", "(India", "Standard", "Time)"]
        // Take the first value from array :)
        datetext = datetext.split(' ')[0];
        const finalHours = datetext.split(':')[0];
        const finalMins = datetext.split(':')[1];
        // console.log(finalHours + ":" + finalMins);
        return finalHours + ":" + finalMins;
    }

    static toAvailability(value: ShiftDto): string[] {
        const availability: string[] = [];
        //Get day (Sunday is zero)
        const startAt = new Date(value.startAt);
        const endAt = new Date(value.endAt);
        let day = "Sun";
        if (startAt.getDay() === 1) {
            day = "Mon";
        }
        if (startAt.getDay() === 2) {
            day = "Tue";
        }
        if (startAt.getDay() === 3) {
            day = "Wed";
        }
        if (startAt.getDay() === 4) {
            day = "Thu";
        }
        if (startAt.getDay() === 5) {
            day = "Fri";
        }
        if (startAt.getDay() === 6) {
            day = "Sat";
        }
        //Shift is AM?
        if (startAt.getHours() <= 11) {
            availability.push(day + "AM");
            //Shift runs into PM?
            if (endAt.getHours() >= 12) {
                if (endAt.getHours() === 12) {
                    if (endAt.getMinutes() > 0) {
                        //Shift end is 12 something but not noon
                        availability.push(day + "PM");
                    }
                } else {
                    availability.push(day + "PM");
                }
            } 
        } else {
            //Shift is PM
            availability.push(day + "PM");
        }
        return availability;
    }

    static toAvailabilityDateSlots(value: ShiftDto): string[] {
        const dateSlots: string[] = [];
        
        const startAt = new Date(value.startAt);
        const endAt = new Date(value.endAt);
        const mm = startAt.getMonth() + 1; // getMonth() is zero-based
        const dd = startAt.getDate();

        const formattedDate = [startAt.getFullYear(), (mm>9 ? '' : '0') + mm, (dd>9 ? '' : '0') + dd].join('');

        //Shift is AM?
        if (startAt.getHours() <= 11) {
            dateSlots.push(formattedDate + "AM");
            //Shift runs into PM?
            if (endAt.getHours() >= 12) {
                if (endAt.getHours() === 12) {
                    if (endAt.getMinutes() > 0) {
                        //Shift end is 12 something but not noon
                        dateSlots.push(formattedDate + "PM");
                    }
                } else {
                    dateSlots.push(formattedDate + "PM");
                }
            } 
        } else {
            //Shift is PM
            dateSlots.push(formattedDate + "PM");
        }
        return dateSlots;
    }

    static toRoundedDate(minutes: number, date: Date): Date {
        const ms = 1000 * 60 * minutes; // convert minutes to ms
        const roundedDate = new Date(Math.round(date.getTime() / ms) * ms);
        return roundedDate
    }
}